<template>
    <div>
        <v-container fluid>
            <template v-if="ebooks && ebooks.length">
                <v-row>
                    <v-col
                        cols="12"
                        md="6"
                        lg="4"
                        v-for="ebook in parsedEBooks"
                        :key="`${ebook.id}-card`"
                    >
                        <v-card class="mx-auto" max-width="400">
                            <v-img
                                @click="loadEbook(ebook.product.ebookfile)"
                                style="background-color:grey;height:400px;"
                                v-if="ebook.product.cover_image_id"
                                class="white--text align-end"
                                :src="ebook.cover_image_url"
                            >
                                <v-card-title>{{
                                    ebook.product.name
                                }}</v-card-title>
                            </v-img>
                            <div
                                @click="loadEbook(ebook.product.ebookfile)"
                                style="background-color:#eeeeee;height:400px;justify-content: center;"
                                class="d-flex flex-column justify-content-center w-100"
                                v-else
                            >
                                <h2 class="text-center primary--text">
                                    {{ ebook.product.name }}
                                </h2>
                            </div>

                            <v-card-subtitle class="pb-0">
                                {{ ebook.product.name }}
                            </v-card-subtitle>

                            <v-card-text class="text--primary">
                                <div v-html="ebook.product.description" />
                            </v-card-text>

                            <v-divider />

                            <v-card-actions>
                                <v-btn
                                    @click="loadEbook(ebook.product.ebookfile)"
                                    color="orange"
                                    text
                                >
                                    Read
                                </v-btn>

                                <v-btn
                                    :disabled="
                                        ebook.product.companion_files.length ===
                                            0
                                    "
                                    @click="viewCompanionFiles(ebook.product)"
                                    color="orange"
                                    text
                                >
                                    View Companion Files ({{
                                        ebook.product.companion_files.length
                                    }})
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
            <template v-else-if="hasLoaded">
                <v-alert color="warning" text>
                    No ebooks found. You can shop for eBooks by visiting the
                    <a
                        target="_blank"
                        href="https://cfma.org/estore/products/browse"
                        >CFMA eStore</a
                    >.
                </v-alert>
            </template>
            <template v-else>
                <v-alert color="info" text>
                    Loading ebooks...
                </v-alert>
            </template>
        </v-container>
        <v-dialog v-model="companionFilesDialog" persistent max-width="600px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Companion Files</v-toolbar-title>
                </v-toolbar>
                <v-container fluid>
                    <v-alert type="warning" v-if="!isConnected">
                        You must be connected to the internet to download companion files.
                    </v-alert>
                    <v-list two-line subheader>
                        <v-list-item
                            v-for="file in companionFiles"
                            :key="file.title"
                        >
                            <v-list-item-avatar>
                                <v-icon
                                    :class="file.color"
                                    dark
                                    v-text="file.icon"
                                ></v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title
                                    v-text="file.title"
                                ></v-list-item-title>

                                <v-list-item-subtitle
                                    v-text="file.subtitle"
                                ></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-btn
                                    link
                                    :href="file.url"
                                    target="_blank"
                                    icon
                                    :disabled="!isConnected"
                                >
                                    <v-icon color="grey lighten-1"
                                    >mdi-download</v-icon
                                    >
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="companionFilesDialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";
export default {
    name: "Ereader",
    data() {
        return {
            companionFilesDialog: false,
            viewCompanionFilesId: false
        };
    },
    props: ["checkOnline"],
    computed: {
        ...mapFields(["loading"]),
        ...mapState([
            "ebooks",
            "ebookStates",
            "currentBook",
            "currentHighlights",
            "currentBookmarks",
            "isSidebarActive",
            "currentPage",
            "autoLoadedBook",
            "hasLoaded",
        ]),
        ...mapState({
            isConnected: "isOnline"
        }),
        canAutoload() {
            return this.autoLoadedBook;
        },
        parsedEBooks() {
            return this.ebooks.map(book => {
                return {
                    ...book,
                    cover_image_url: book.product.cover_image_id
                        ? `${process.env.VUE_APP_API_URL}files/o-files/view-file/${book.product.cover_image_id}`
                        : null
                };
            });
        },
        companionFiles() {
            if (!this.ebooks || !this.ebooks.length) {
                return [];
            }

            const ebook = this.ebooks.find(
                ebook => ebook.product.id === this.viewCompanionFilesId
            );

            if (!ebook) return [];

            return ebook.product.companion_files.map(file => {
                return {
                    title: file.filename,
                    subtitle: (file.size / 1024 / 1024).toFixed(2) + "mb",
                    icon:
                        file.mime === "application/pdf"
                            ? "mdi-file-pdf-box"
                            : "mdi-file",
                    color: "blue",
                    url: process.env.VUE_APP_API_URL + file.url
                };
            });
        }
    },
    watch: {
        // isConnected() {
        //     this.getBooks(this.isConnected);
        // },
        canAutoload(newCount) {
            if (newCount) {
                this.loadEbook(this.currentBook);
                this.$router.push(`/`);
            }
        }
    },
    methods: {
        ...mapActions(["getBooks", "setHighlights"]),
        ...mapMutations(["setBookState"]),
        loadEbook(bookId) {
            this.$router.push({ name: "viewEBook", params: { id: bookId } });
        },
        viewCompanionFiles(product) {
            console.log(product);
            this.viewCompanionFilesId = product.id;
            this.companionFilesDialog = true;
        }
    },
    mounted() {
        this.getBooks(this.isConnected);
    }
};
</script>
